import axios from 'axios'
import router from '../../router'

const state = {
	auth: null,
	user: null,
	role: null,
	token: null,
	loginStatus: null
}

const mutations = {
	authUser(state, userData) {
		state.token = userData
		state.auth = true
	},
	storeUser(state, user) {
		state.user = user
	},
	storeUserRole(state, role) {
		state.role = role
	},
	loginPending(state) {
		state.loginStatus = 'PENDING'
	},
	loginError(state) {
		state.loginStatus = 'ERROR'
	},
	loginInit(state) {
		state.loginStatus = null
	},
	logout(state) {
		state.token = null
		state.user = null
		state.auth = null
	}
}

const actions = {
	login({ commit }, authData) {
		const urlParams = new URLSearchParams(window.location.search)
		commit('loginPending')
		axios
			.post('/auth/login', {
				email: authData.email,
				password: authData.password
			})
			.then(res => {
				commit('storeUser', res.data.user)
				commit('storeUserRole', res.data.user.role)
				commit('authUser', res.data.token)

				const vuex = JSON.parse(localStorage.getItem('vuex'))
				axios.defaults.headers.common[
					'Authorization'
				] = `Bearer ${vuex.login.token}`

				if (
					urlParams.get('response_type') &&
					urlParams.get('client_id') &&
					urlParams.get('redirect_uri') &&
					urlParams.get('state')
				) {
					window.location =
						window.location.origin + '/oauth' + window.location.search
				} else {
					router.push('/')
				}

				commit('loginInit')
			})
			.catch(() => {
				commit('loginError')
			})
	},
	logout({ commit }) {
		commit('logout')
		localStorage.removeItem('vuex')
		router.push('/login')
	}
}

const getters = {
	user: state => {
		return state.user
	},
	auth: state => {
		return state.auth
	},
	role: state => {
		return state.role
	},
	loginStatus: state => {
		return state.loginStatus
	}
}

const namespaced = true

export default {
	namespaced,
	state,
	mutations,
	actions,
	getters
}
